import React, { useState, useEffect } from 'react';
import { getVideos } from '../api/videoApi';
import { getImages } from '../api/imageApi';
import { getPdfs } from '../api/pdfApi';
import { getLinks } from '../api/linkApi';
import Footer from './Footer';

function Media() {
  const [videos, setVideos] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");



  useEffect(() => {
    const fetchMedia = async () => {
      try {
        console.log("🔵 Fetching videos, images, and PDFs...");

        const [videoData, imageData, pdfData, linkResponse] = await Promise.all([
          getVideos("Media"), getImages("Media"), getPdfs("Media"), getLinks("Media")
        ]);

        const sortedVideos = [...videoData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        console.log("🟢 API Response - Images:", imageData);
        console.log("🟢 API Response - Videos:", videoData);
        console.log("🟢 API Response - PDFs:", pdfData);
        console.log("🟢 API Response - Links:", linkResponse);

        setVideos(videoData);
        setImages(imageData);
        setPdfs(pdfData);
        setLinks(linkResponse);
        setVideos(sortedVideos);
      } catch (err) {
        console.error("❌ Error fetching media", err);
        setError("Failed to load media.");
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);

  if (loading) return <p className="text-center text-gray-600">Loading media...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;


  return (
    // <div className="max-w-6xl mx-auto px-6 py-12">
    // <div className="px-6 py-12">

    <div className="w-full">
      {/* <div className="bg-gradient-to-r from-[#003366] to-[#006d66] text-white py-4 px-6 w-full mb-12"> */}
      {/* Page Title & Intro */}
      {/* <div className="text-center mt-12 mb-12">
        <h1 className="text-5xl font-bold text-primary">Media</h1>  
        <p className="text-lg text-black mt-3 max-w-3xl mx-auto">
          At The Owen Lab, we collaborate with major media organizations to share our scientific research with a broader audience. Below are some of our featured appearances and content.
        </p>
        <p className="text-lg font-semibold text-black mt-4">For media enquiries, please contact <a href="mailto:jrenaud9@uwo.ca" className="text-secondary hover:underline">jrenaud9@uwo.ca</a></p>
      </div> */}


      {/* Logos Section */}
      {/* <SectionCard title="Featured In">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 place-items-center">
          {[
            { src: "/BBC-logo.png", alt: "BBC" },
            { src: "/CBC-logo.png", alt: "CBC" },
            { src: "/GlobalNews-logo.jpeg", alt: "Global News" },
            { src: "/DailyPlanet-logo.jpeg", alt: "Daily Planet" },
          ].map((logo, index) => (
            <img
              key={index}
              className="w-40 h-24 object-contain rounded-md shadow-md"
              src={logo.src}
              alt={logo.alt}
              onError={(e) => (e.target.src = "/default-placeholder.png")}
            />
          ))}
        </div>
      </SectionCard> */}

      {/* Gradient Bar with Logos */}
      <div className="bg-gradient-to-r from-[#003366] to-[#006d66] text-white py-4 px-6 w-full mb-12">
        {/* <h1 className="text-5xl font-bold text-center text-white">Media</h1> */}
        {/* <p className="text-lg text-white text-center mt-3 max-w-3xl mx-auto">
          At The Owen Lab, we collaborate with major media organizations to share our scientific research with a broader audience. Below are some of our featured appearances and content.
        </p> */}
        <h2 className="text-3xl font-semibold text-center mt-2 mb-6">Featured In</h2>
        {/* <div className="grid grid-cols-2 md:grid-cols-5 gap-6 place-items-center"> */}
        <div className="grid grid-cols-5 gap-4 place-items-center">
          {[
            { src: "/12_BBC-Radio-1_logo.png", alt: "BBC" },
            { src: "/CNN-Transparent.png", alt: "CNN" },
            { src: "/CBC-transparent.png", alt: "CBC" },
            { src: "/1_channel_4_logo.png", alt: "Channel 4" },
            { src: "/17_BBC-Three_logo.png", alt: "BBC Three" },
            { src: "/60_Mins-Transparent.png", alt: "60 Mins" },
            { src: "/Radio4-Transparent.png", alt: "Radio 4" },
            { src: "/18_ITV_logo.png", alt: "ITV" },
            { src: "/TVO-Transparent.png", alt: "TVO" },
            { src: "/Planet-transparent.png", alt: "Planet" },
            { src: "/Panorama-transparent.png", alt: "Panorama" },
            { src: "/Nature-transparent.png", alt: "Nature" },
            { src: "/InsideOut.png", alt: "InsideOut" },
            { src: "/FinalHorizon.png", alt: "FinalHorizon" },
            { src: "/Discovery-Transparent.png", alt: "Discovery" },
          ].map((logo, index) => (
            // <img
            //   key={index}
            //   className="w-40 h-24 object-contain rounded-md shadow-md"
            //   src={logo.src}
            //   alt={logo.alt}
            //   onError={(e) => (e.target.src = "/default-placeholder.png")}
            // />
            <img
              key={index}
              src={logo.src}
              alt={logo.alt}
              onError={(e) => (e.target.src = "/default-placeholder.png")}
              className="
              w-24
              sm:w-32
              md:w-40
              h-auto
              object-contain
              rounded-md
              shadow-md

              "
            />
          ))}
        </div>

      </div>
      {/* </div> */}
      <h1 className="text-5xl font-bold text-center text-primary">Watch Us</h1>
      <p className="text-md text-black font-bold text-center mt-3 max-w-3xl mx-auto mb-6">
        At the Owen Lab, we collaborate with major media organizations to share our scientific research with a broader audience. Below are some of our featured appearances and content.
      </p>

      {/* Media Sections */}
      {/* <div className="space-y-12"> */}
      <div className="max-w-6xl mx-auto px-6 space-y-12">
        {/* Videos */}
        {/* <SectionCard title="Featured Videos"> */}
        <SectionCard>
          {videos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((video) => (
                // <MediaCard key={video._id} title={video.title}>
                <MediaCard key={video._id}>
                  {/* <video className="w-full rounded-md shadow-lg" controls>
                    <source src={video.fileUrl ? `http://localhost:5555${video.fileUrl}` : video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video> */}
                  {video.fileUrl ? (
                    // <video className="w-full rounded-md shadow-lg" controls>
                    <video
                      className="w-full max-w-lg aspect-video rounded-md shadow-lg mx-auto"
                      controls
                    >
                      <source src={`http://localhost:5555${video.fileUrl}`} type="video/mp4" />
                    </video>
                  ) : (
                    <iframe
                      // className="w-full h-40 rounded-md"
                      className="w-full max-w-lg aspect-video rounded-md mx-auto"
                      src={video.url.replace("watch?v=", "embed/")}
                      title={video.title}
                      allowFullScreen
                    />
                  )}

                  <h3 className="text-lg font-semibold mt-2 text-center text-primary">{video.title}</h3>

                </MediaCard>
              ))}
            </div>
          ) : (
            <NoContent text="No videos found." />
          )}
        </SectionCard>

        {/* Images */}
        {/* <SectionCard title="Images">
          {images.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {images.map((image) => (
                <MediaCard key={image._id} title={image.title}>
                  
                  <img
                    className="w-full h-auto rounded-md mt-2 object-cover"
                    src={image.imageUrl} // ✅ This always holds the correct URL
                    alt={image.title || "Uploaded Image"}
                    onError={(e) => (e.target.src = "/default-placeholder.png")} // ✅ Fallback if image fails to load
                  />


                </MediaCard>
              ))}
            </div>
          ) : (
            <NoContent text="No images found." />
          )}
        </SectionCard> */}

        {/* PDFs */}
        {/* <SectionCard title="PDFs">
          {pdfs.length > 0 ? (
            <ul className="space-y-2">
              {pdfs.map((pdf) => (
                <li key={pdf._id}>
                  <button
                    onClick={() => {
                      let pdfLink = pdf.pdfUrl || pdf.fileUrl || pdf.url;

                      if (!pdfLink) {
                        alert("PDF link is missing.");
                        console.error("❌ No valid PDF URL found!", pdf);
                        return;
                      }
                      if (!pdfLink.startsWith("http")) {
                        // pdfLink = `http://localhost:5555${pdfLink}`;
                        pdfLink = `http://localhost:5555${pdfLink.replace(/^\/+/, '')}`;
                      }
                      window.open(pdfLink, "_blank", "noopener,noreferrer");
                    }}
                    className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
                  >
                    {pdf.title || "Untitled PDF"}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <NoContent text="No PDFs found." />
          )}
        </SectionCard> */}

        {/* External Links */}
        {/* <SectionCard title="External Links">
          {links.length > 0 ? (
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link._id}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
                  >
                    {link.title || "Untitled Link"}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <NoContent text="No external links found." />
          )}
        </SectionCard> */}
      </div>
      <Footer isFullFooter={false} />
    </div>
  );
}

/* Section Wrapper */
const SectionCard = ({ title, children }) => (
  <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-6">
    <h2 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h2>
    {children}
  </section>
);

/* Card for Media Items */
const MediaCard = ({ title, children }) => (
  <div className="bg-gray-50 rounded-lg p-4 border border-gray-300 shadow-md">
    <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
    {children}
  </div>
);

/* Placeholder for Empty Sections */
const NoContent = ({ text }) => <p className="text-gray-500">{text}</p>;

export default Media;
